import { render } from "./GuestChat.vue?vue&type=template&id=6a721faf&scoped=true"
import script from "./GuestChat.vue?vue&type=script&lang=js"
export * from "./GuestChat.vue?vue&type=script&lang=js"

import "./GuestChat.vue?vue&type=style&index=0&id=6a721faf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a721faf"]])

export default __exports__